var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.value || false,"timeout":_vm.computedTimeout,"bottom":"","left":!_vm.$vuetify.rtl,"right":_vm.$vuetify.rtl,"transition":"scroll-y-reverse-transition"},on:{"input":(newValue) => _vm.$emit('input', newValue)}},[_c('VcAlert',_vm._b({attrs:{"width":288,"is-stripe":false}},'VcAlert',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }